import { Head, Link } from "@inertiajs/react";
import { Sparkles } from "lucide-react";

interface BlogLayoutProps {
  title?: string;
  children: React.ReactNode;
}

export function BlogLayout({ title, children }: BlogLayoutProps) {
  return (
    <div className="min-h-screen bg-background text-foreground">
      {title && <Head title={title} />}

      {/* Public navbar */}
      <nav className="sticky top-0 z-30 border-b border-border bg-background/80 backdrop-blur">
        <div className="mx-auto flex max-w-6xl items-center justify-between px-4 py-3">
          <Link href="/" className="flex items-center gap-3">
            <div className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary/20 text-primary">
              <Sparkles size={18} />
            </div>
            <span className="text-lg font-semibold text-foreground">fotoCerta</span>
          </Link>
          <div className="flex items-center gap-4">
            <Link
              href="/blog"
              className="text-sm font-medium text-foreground/80 transition-colors hover:text-foreground"
            >
              Blog
            </Link>
            <Link
              href="/"
              className="text-sm font-medium text-foreground/80 transition-colors hover:text-foreground"
            >
              Entrar
            </Link>
          </div>
        </div>
      </nav>

      <main>{children}</main>

      {/* Footer */}
      <footer className="border-t border-border bg-background/80">
        <div className="mx-auto flex max-w-6xl flex-col items-center gap-3 px-4 py-6 text-xs text-muted-foreground sm:flex-row sm:justify-between">
          <span>&copy; {new Date().getFullYear()} fotoCerta. Feito no Brasil.</span>
          <div className="flex flex-wrap justify-center gap-4">
            <Link href="/blog" className="transition-colors hover:text-foreground">
              Blog
            </Link>
            <span className="text-border">|</span>
            <a href="mailto:contato@fotocerta.com" className="transition-colors hover:text-foreground">
              Contato
            </a>
            <span className="text-border">|</span>
            <a href="https://instagram.com/fotocerta.app" target="_blank" rel="noopener noreferrer" className="transition-colors hover:text-foreground">
              Instagram
            </a>
            <span className="text-border">|</span>
            <Link href="/termos" className="transition-colors hover:text-foreground">
              Termos de Uso
            </Link>
            <span className="text-border">|</span>
            <Link href="/privacidade" className="transition-colors hover:text-foreground">
              Privacidade
            </Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
